<template>
  <div class="news-detail view-container">
    <!-- 面包屑 -->
    <BreadCrumb class="bread-crumb"></BreadCrumb>
    <component :is="componentId"></component>
  </div>
</template>

<script>
import { components } from './detail/index'

export default {
  components: {
    ...components
  },
  data () {
    return {
    }
  },
  created () {
    this.componentId = this.$route.params.id
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.news-detail {
  padding-top: 40px;
  /deep/ .article {
    padding: 60px 0 120px;
    &-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
      text-align: center;
    }
    &-time {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6D6E77;
      line-height: 16px;
      text-align: center;
      margin: 20px 0;
    }
    &-body {
      padding-top: 40px;
      border-top: 1px dashed #D6D6D6;
    }
    &-para {
      font-size: 16px;
      color: #6D6E77;
      line-height: 28px;
      margin-bottom: 40px;
    }
    &-h2 {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1D2130;
      line-height: 24px;
      margin-bottom: 40px;
    }
    &-h3 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1D2130;
      line-height: 16px;
      margin-bottom: 40px;
    }
    &-h3-sub {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1D2130;
      line-height: 16px;
      margin-bottom: 20px;
    }
    &-img-max-1000 {
      width: 100%;
      max-width: 1000px;
      height: auto;
      margin: 0 auto 40px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    &-img-small {
      width: 100%;
      max-width: 1000px;
      // height: 340px;
      margin: 0 auto 40px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    &-img-big {
      width: 100%;
      max-width: 1000px;
      // height: 490px;
      margin: 0 auto 40px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media (max-width: 750px) {
  .news-detail {
    padding-top: 0;
    .bread-crumb {
      height: 35px;
      line-height: 35px;
      background: #F5F5F5;
      margin: 0 -15px;
      padding: 0 15px;
    }
    /deep/ .article {
      padding: 15px 0 30px;
      &-title {
        font-size: 20px;
        line-height: 28px;
        text-align: left;
      }
      &-time {
        font-size: 14px;
        color: #686868;
        line-height: 14px;
        text-align: left;
        margin: 16px 0;
      }
      &-body {
        padding-top: 24px;
        border-top: 1px solid #d8d8d8;
      }
      &-para {
        font-size: 14px;
        color: #686868;
        line-height: 20px;
        margin-bottom: 15px;
      }
      &-h2 {
        font-size: 17px;
        color: #333;
        line-height: 23px;
        margin-bottom: 10px;
      }
      &-h3 {
        font-size: 14px;
        color: #333;
        line-height: 18px;
        margin-bottom: 10px;
      }
      &-h3-sub {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #1D2130;
        line-height: 14px;
        margin-bottom: 10px;
      }
      &-img-max-1000 {
        width: 100%;
        max-width: 1000px;
        height: auto;
        margin: 0 auto 20px;
        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      &-img-small {
        width: 100%;
        max-width: 100%;
        // height: 100px;
        margin: 0 auto 20px;
        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      &-img-big {
        width: 100%;
        max-width: 100%;
        // height: 184px;
        margin: 0 auto 20px;
        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
